var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCameraOn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1828 0.20752C15.1206 0.20752 15.8809 0.967791 15.8809 1.90563L15.8807 5.21552L19.927 1.16932C20.3249 0.77143 20.97 0.77143 21.3679 1.16932C21.559 1.3604 21.6664 1.61955 21.6664 1.88977V12.1102C21.6664 12.6729 21.2102 13.129 20.6475 13.129C20.3773 13.129 20.1181 13.0217 19.927 12.8306L15.8807 8.78352L15.8809 12.0943C15.8809 13.0322 15.1206 13.7924 14.1828 13.7924H2.03185C1.09401 13.7924 0.33374 13.0322 0.33374 12.0943V1.90563C0.33374 0.967791 1.09401 0.20752 2.03185 0.20752H14.1828Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCameraOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/camera-on.37e697728ba8ca5a7bfcadc84b29ccda.svg";